<template>
    <div class="shopName"><i class="iconfont iconicon_dianpu"></i>{{ name }}</div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.shopName {
    font-size: 28px;
    color: #000;
    display: flex;
    align-items: self-end;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    white-space: normal;
    word-break: break-all;
    /* padding: 0 16px; */
    .iconicon_dianpu {
        color: #666666;
        font-size: 30px;
        margin-right: 12px;
        vertical-align: bottom;
    }
}
</style>